import React from "react";
import { Link } from "react-router-dom";

export const cityColumns = (
  handleEdit,
  handleDelete,
  PAGE_SIZE,
  handleStatusToggle,
  handleWebsiteToggle
) => [
  {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Country",    
    render: (row) => (row.country_id?.name ? row.country_id.name : "N/A"),    
  },
  {
    label: "State",
    render: (row) => (row.state_id?.name ? row.state_id.name : "N/A"),     
  },
  {
    label: "City",
    key: "name",
    sortKey: "name",       
    sortable: true,     
  },
  {
    label: "All Platform Status",
    key: "status",      
    width: 140,
    sortable: true,
    render: (row) => (
      <div
        className="checkbox-wrapper-8"
        style={{ cursor: "pointer" }}
        onClick={() => handleStatusToggle && handleStatusToggle(row)}
        title="Click to toggle All Platform Status"
      >
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={row.status === "Active"}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Inactive"
          data-tg-on="Active"
        />
      </div>
    ),
  },
  {
    label: "Website",
    width: 90,
    render: (row) => (
      <input
        type="checkbox"
        checked={row.status === "Active" && !!row.website}
        disabled={row.status !== "Active"}
        onChange={() => handleWebsiteToggle && handleWebsiteToggle(row)}
        title={row.status !== "Active" ? "Activate city to enable" : "Show on Website"}
      />
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link to="#" onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link to="#" onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
];
